import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import style from './Form.module.scss';
import { isValidEmail } from '@helpers';

const initialState = {
  company: '',
  email: '',
  question: '',
  question2: '',
  counter: 0,
  schedule_call: 'Yes',
};

const errors = { email: 'email', company: 'company' };

const CONTACT_FORM_URL = process.env.GATSBY_CONTACT_FORM_URL;
const MIN_COUNTER_VALUE = 0;
const MAX_COUNTER_VALUE = 100;

const getUserEmailProvider = (mail) => {
  const splitted = mail.split('@');
  const provider = splitted[1];

  return provider;
};

const Form = ({ content }) => {
  const {
    body,
    successinformer,
    button,
    company,
    counter,
    email,
    question,
    question2,
    wrong_email,
    required_field,
    schedule_call,
  } = content;
  const { text: successInformerText } = successinformer;
  const [formState, setFormState] = useState(initialState);
  const [formErrors, setFormErrors] = useState([]);
  const [recaptchaError, setRecaptchaError] = useState(null);
  const [recaptchaLoad, setRecaptchaLoad] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [isSubmitted, setSubmited] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const reCaptchRef = useRef(null);
  const providersData = body.find(
    (element) => element.slice_type === 'providers'
  );
  const { items: rawProviders } = providersData;
  const providers = rawProviders.map(({ provider }) => provider.text);

  const handleInputChange = ({ target: { name, value } }) => {
    setFormState((state) => ({ ...state, [name]: value }));
    formErrors.length > 0 &&
      setFormErrors([...formErrors.filter((error) => error != name)]);
  };

  const handleChangeCounter = (value) => {
    if (value >= MIN_COUNTER_VALUE && value <= MAX_COUNTER_VALUE) {
      setFormState((state) => ({ ...state, ['counter']: value }));
    }
  };

  const handleCloseInformer = (informerType) => {
    const mapping = {
      successInformer: setSubmited(false),
      errorInformer: setSubmitError(null),
    };

    return mapping[informerType];
  };

  const validateForm = (companyName, userEmail) => {
    const userEmailProvider = getUserEmailProvider(userEmail);

    const isValidCompany = companyName.trim() !== '';
    const isValidUserEmail =
      isValidEmail(userEmail) && !providers.includes(userEmailProvider);

    if (!isValidCompany) {
      setFormErrors([...formErrors, errors.company]);
    }

    if (!isValidUserEmail) {
      setFormErrors([...formErrors, errors.email]);
    }

    const validForm = isValidCompany && isValidUserEmail;

    return validForm;
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    fetch(CONTACT_FORM_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: new FormData(e.target),
    })
      .then(() => {
        setSubmited(true);
        setFormState(initialState);
      })
      .catch((err) => {
        setSubmitError(err);
      });
  };
  const handleCaptureVerify = (token) => {
    setRecaptchaToken(token);
  };

  return (
    <form className={style.form} onSubmit={handleOnSubmit}>
      <>
        <iframe
          id="JotFormIFrame-241301827720347"
          role="form"
          title="Contact Us form"
          allow="geolocation; microphone; camera; fullscreen"
          src="https://form.jotform.com/241301827720347"
          frameborder="0"
          style="width: inherit;
              height: 1150px;"
        />
      </>
    </form>
  );
};

Form.propTypes = {
  content: PropTypes.object,
};

export default Form;
